
export default class ConfigReader {
  static get CONFIG () {
    return {
      apiHost: '$APP_API_HOST',
      stayinUrlBookingDetails: '$APP_STAYIN_URL_BOOKING_DETAILS',
      stayinUrlObjectDetails: '$APP_STAYIN_URL_OBJECT_DETAILS',
      stayinUrlGuestDetails: '$APP_STAYIN_URL_GUEST_DETAILS',
    };
  }

  static value (name) {
    if (!(name in this.CONFIG)) {
      window.console.log(`Configuration: There is no key named "${name}"`);
      return;
    }

    const value = this.CONFIG[name];

    if (typeof value === 'undefined') {
      window.console.log(`Configuration: Value for "${name}" is not defined`);
      return;
    }

    if (value.startsWith('$APP_')) {
      // Remove $ and get current value from process.env
      const envName = value.substr(1);

      // value was not replaced, it seems we are in development.
      let envValue = null;
      // need to fully reference process.env variable, so dotenv-webpack can substitute in dev-server
      switch (envName) {
      case 'APP_API_HOST':
        envValue = process.env.APP_API_HOST;
        break;
      case 'APP_STAYIN_URL_BOOKING_DETAILS':
        envValue = process.env.APP_STAYIN_URL_BOOKING_DETAILS;
        break;
      case 'APP_STAYIN_URL_OBJECT_DETAILS':
        envValue = process.env.APP_STAYIN_URL_OBJECT_DETAILS;
        break;
      case 'APP_STAYIN_URL_GUEST_DETAILS':
        envValue = process.env.APP_STAYIN_URL_GUEST_DETAILS;
        break;
      }
      if (envValue) {
        return envValue;
      } else {
        window.console.log(`Configuration: Environment variable "${envName}" is not defined`);
      }
    } else {
      // value was already replaced, it seems we are in production.
      return value;
    }
  }
}
